import { bool, func } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const RecreationConfirmation = ({ toggle, setToggle, onClick }) => {
  return (
    <Modal isOpen={toggle} toggle={setToggle} size="md">
      <ModalHeader toggle={setToggle}>Re-create Campaign</ModalHeader>
      <ModalBody>
        Keep in mind that you will lose any manual input that you might have
        done in the campaign view (e.g. adding SKUs, LPs, CTA, Byline and
        Title). When re-created, Sales Cockpit will provide default copies and
        empty SKU lists per campaign. Are you sure you want to re-create your
        campaign?
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClick}>
          Yes
        </Button>
        <Button color="secondary" onClick={setToggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

RecreationConfirmation.propTypes = {
  toggle: bool.isRequired,
  setToggle: func.isRequired,
  onClick: func.isRequired,
};

export default RecreationConfirmation;
